<template>
  <Mobile v-if="$isMobile()"/>
    <PC v-else/>

</template>

<script>
import { defineComponent } from 'vue';
import PC from './views/PC.vue';
import Mobile from './views/Mobile.vue';

export default defineComponent({
  name: 'App',
  components: {
    PC,
    Mobile
  },
});
</script>

